import { ProjectExpense, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeProjectExpense(httpClient: HttpClient) {
  return (projectExpense: ProjectExpense) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/expenses/${projectExpense.uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { removeProjectExpense };
